import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/crm-partners',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: 'share.value',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: 'Posiadane udziały',
      badge: 'Posiadane udziały:',
      testName: 'test_filter_invoice_total_net_value',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'number',
    },
    {
      key: 'partnercrmapprovalrequest.status',
      getItems: async () => [
        { value: 1, label: 'Oczekuje' },
        { value: 2, label: 'Powiązano' },
        { value: 3, label: 'Odrzucono' },
      ],
      reset: async () => null,
      placeholder: 'Status',
      badge: 'Status:',
      testName: 'dropdown_list_filter_is_company',
      inputType: FiltersType.SELECT_TYPE,
    },
  ],
};
